// extracted by mini-css-extract-plugin
export var notificationHost = "_gu-0";